/**
 * <featured-collection-tabs> — Tab navigation Web Component.
 *
 * Switches visible product panels based on tab button clicks.
 * Uses event delegation on the tab bar and toggles `is-active`
 * classes on both buttons and panels.
 *
 * Used by sections/featured-collections.liquid.
 */

class FeaturedCollectionTabs extends HTMLElement {
  connectedCallback() {
    this.tabBar = this.querySelector('.featured-collections__tabs');
    this.panels = [...this.querySelectorAll('.featured-collections__panel')];
    if (!this.tabBar || this.panels.length === 0) return;

    this.handleClick = this.handleClick.bind(this);
    this.tabBar.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.tabBar?.removeEventListener('click', this.handleClick);
  }

  handleClick(event) {
    const button = event.target.closest('.featured-collections__tab');
    if (!button) return;

    const { index } = button.dataset;
    if (!index) return;

    const buttons = [...this.tabBar.querySelectorAll('.featured-collections__tab')];
    for (const btn of buttons) {
      const isActive = btn.dataset.index === index;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-selected', String(isActive));
      btn.setAttribute('tabindex', isActive ? '0' : '-1');
    }

    for (const panel of this.panels) {
      const isActive = panel.dataset.index === index;
      panel.classList.toggle('is-active', isActive);
      panel.setAttribute('aria-hidden', String(!isActive));
    }
  }
}

if (!customElements.get('featured-collection-tabs')) {
  customElements.define('featured-collection-tabs', FeaturedCollectionTabs);
}
